import { computed, Directive, effect, inject, input } from '@angular/core';
import { ProductComponentStore, ProductId, productIdentifierAttribute } from 'products-data';
import { ProductOrItemComponentBase } from '../ProductOrItemComponentBase';

@Directive()
export abstract class ProductComponentBase extends ProductOrItemComponentBase<ProductId> {
  protected readonly productStore = inject(ProductComponentStore);

  public override readonly id = input.required({
    alias: 'productId',
    transform: productIdentifierAttribute,
  });

  protected readonly product = this.productStore.product;
  protected readonly productType = computed(() => this.product()?.id.type || null);
  protected readonly productDescription = computed(() => this.product()?.description || '');

  protected readonly thumbnailUrl = computed(() => this.product()?.thumbnail ?? '');

  constructor() {
    super();
    effect(() => this.productStore.setSelectedProductId(this.productId()));
  }
}
